import React, { FC } from "react";
import { useLocation } from "react-router-dom";

import AuthFlowLayout from "../../layouts/AuthFlowLayout";
import ConfirmVerificationCodeForm from "./components/ConfirmVerificationCodeForm";
import SignUpForm from "./components/SignUpForm";

const SignUpPage: FC = () => {
  const location = useLocation();

  const { userName } = Object.fromEntries(new URLSearchParams(location.search));

  return (
    <AuthFlowLayout
      heading="Join BrandGen.io"
      description="Create account: to view your personalized dashboard, campaigns, and audiences."
    >
      {userName ? <ConfirmVerificationCodeForm userName={userName} /> : <SignUpForm />}
    </AuthFlowLayout>
  );
};

export default SignUpPage;
